module.exports = __webpack_public_path__ + "static/img/datashare2.d8e71d30.png";